/* eslint-disable react/prop-types */

import { Box, Checkbox, Grid, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import DatePicker from 'react-multi-date-picker';
import constants, {
  DATE_SAVE_TO_DB_WITH_FORMAT,
  DATE_TO_SHOW_WITH_FORMAT,
  LOS_SEARCH_OPTIONS,
} from '../../constants';
import { allowAlphaNumeric } from '../../utils/helper';
import InputComponent from '../Input';
import Label from '../Label';
import StyledInputWrapper from './Forms.styled';
import SelectionDropdown from './SelectionDropdown';
import SiteDropdown from './SiteDropdown';
import JobDropdown from './JobDropdown';
import SupervisorStatusDropdown from './SupervisorStatusDropdown';
import Dropdown from '../Dropdown';

const SearchWorker = function ({ data, setData, validations, workerType }) {
  const { user_details: userDetails } = useSelector((state) => state.authentication);
  return (
    <Box p="10px">
      <StyledInputWrapper style={{ marginRight: '8px' }}>
        <InputComponent
          lable={constants.FIRST_NAME}
          placeholder={constants.FIRST_NAME}
          onChange={(e) => setData({ ...data, first_name: allowAlphaNumeric(e) })}
          value={data.first_name}
          validationObj={validations.first_name}
          // refresh={refresh}
          maxLength="50"
        />
      </StyledInputWrapper>
      <StyledInputWrapper>
        <InputComponent
          lable={constants.LAST_NAME}
          placeholder={constants.LAST_NAME}
          onChange={(e) => setData({ ...data, last_name: allowAlphaNumeric(e) })}
          value={data.last_name}
          validationObj={validations.last_name}
          // refresh={refresh}
          maxLength="50"
        />
      </StyledInputWrapper>
      <Flex>
        <StyledInputWrapper>
          <InputComponent
            lable={constants.EMPLOYEE_ID}
            placeholder={constants.EMPLOYEE_ID}
            onChange={(e) => setData({ ...data, employee_id: e })}
            value={data.employee_id}
            validationObj={validations.employee_id}
            // refresh={refresh}
            maxLength="50"
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper>
          <InputComponent
            lable={constants.PAYROLL_REF}
            placeholder={constants.PAYROLL_REF}
            onChange={(e) => setData({ ...data, payroll_ref: e })}
            value={data.payroll_ref}
            validationObj={validations.payroll_ref}
            // refresh={refresh}
            maxLength="50"
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper>
          <InputComponent
            lable={constants.NATIONAL_INSURANCE_NUMBER}
            placeholder={constants.NATIONAL_INSURANCE_NUMBER}
            onChange={(e) => setData({ ...data, national_insurance_number: e })}
            value={data.national_insurance_number}
            validationObj={validations.national_insurance_number}
            // refresh={refresh}
            maxLength="50"
            // disabled={edit && true}
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper>
          <InputComponent
            lable={constants.EMAIL}
            placeholder={constants.EMAIL}
            onChange={(e) => setData({ ...data, email: e })}
            value={data.email}
            validationObj={validations.email}
            // refresh={refresh}
            maxLength="50"
            // disabled={edit && true}
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            lable={constants.PENSION_OPT_OUT_STATUS}
            validationObj={validations.pension}
            // refresh={refresh}
            Dropdownvalue={data.pension_opt_out}
            setDropdownvalue={(e) =>
              setData({ ...data, pension_opt_out: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            lable={constants.APP_DOWNLOADED}
            validationObj={validations.app_downloaded}
            // refresh={refresh}
            Dropdownvalue={data.app_downloaded}
            setDropdownvalue={(e) =>
              setData({ ...data, app_downloaded: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            validationObj={validations.other_assignment}
            lable={constants.OTHER_ASSIGNMENT}
            // refresh={refresh}
            Dropdownvalue={data.other_assignment}
            setDropdownvalue={(e) =>
              setData({ ...data, other_assignment: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            validationObj={validations.banking_details}
            lable={constants.BANKING_DETAILS}
            // refresh={refresh}
            Dropdownvalue={data.banking_details}
            setDropdownvalue={(e) =>
              setData({ ...data, banking_details: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
      </Flex>

      {/* New Search Fields */}
      <Flex>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            validationObj={validations.student_visa}
            lable={constants.STUDENT_VISA}
            Dropdownvalue={data.student_visa}
            setDropdownvalue={(e) =>
              setData({ ...data, student_visa: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SelectionDropdown
            validationObj={validations.limited_hours}
            lable={constants.LIMITED_HOURS}
            // refresh={refresh}
            Dropdownvalue={data.limited_hours}
            setDropdownvalue={(e) =>
              setData({ ...data, limited_hours: { label: e.value, value: e.value } })
            }
          />
        </StyledInputWrapper>
      </Flex>

      <Flex>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SiteDropdown
            lable="Site"
            validationObj={validations.site_id}
            site={data.site_id}
            setSite={(e) =>
              setData({
                ...data,
                site_id: e,
                role_id: { label: '', value: '' }, // Reset job/role when site changes
              })
            }
          />
        </StyledInputWrapper>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <p className="input-label">Assignment Date</p>
          <DatePicker
            locale="en"
            format={userDetails.date_format}
            inputClass="date-picker"
            placeholder="Select Date"
            value={
              data.assignment_date
                ? DATE_TO_SHOW_WITH_FORMAT(data.assignment_date, userDetails.date_format)
                : ''
            }
            onChange={(e) =>
              e &&
              setData({
                ...data,
                assignment_date: DATE_SAVE_TO_DB_WITH_FORMAT(e.toString(), userDetails.date_format),
              })
            }
            editable={false}
            className="booking-datepicker"
          />
        </StyledInputWrapper>
      </Flex>
      <Flex>
        <StyledInputWrapper>
          <JobDropdown
            validationObj={validations.role_id}
            roleType={data.role_id}
            setRoleType={(e) => setData({ ...data, role_id: e })}
            siteId={data.site_id?.value}
          />
        </StyledInputWrapper>
      </Flex>

      <Flex>
        <StyledInputWrapper style={{ marginRight: '8px' }}>
          <SupervisorStatusDropdown
            label="Supervisor Status"
            validationObj={validations.supervisor_status}
            supervisorStatusValue={data.supervisor_status}
            setSupervisorStatusData={(e) => setData({ ...data, supervisor_status: e })}
            supervisorStatusList={[
              { label: 'Back Office', value: 'BACK_OFFICE' },
              { label: 'Front Office', value: 'FRONT_OFFICE' },
              { label: 'Both (FO + BO)', value: 'BOTH' },
            ]}
          />
        </StyledInputWrapper>
        <StyledInputWrapper>
          <Dropdown
            label="Length of Service (LOS)"
            placeholder="Select LOS"
            options={LOS_SEARCH_OPTIONS}
            onSelect={(e) => setData({ ...data, los: e })}
            value={data.los}
            isError={validations.los && !validations.los.isvalid}
          />
        </StyledInputWrapper>
      </Flex>

      <Grid templateColumns="repeat(2, 1fr)">
        <Checkbox
          size="lg"
          isChecked={data.under_twentyone}
          onChange={(e) => setData({ ...data, under_twentyone: e.target.checked })}
        >
          <Label label="U21 Year" color="main.primary" checkbox />
        </Checkbox>
        <Checkbox
          size="lg"
          isChecked={data.under_twentytwo}
          onChange={(e) => setData({ ...data, under_twentytwo: e.target.checked })}
        >
          <Label label="U22 Year" color="main.primary" checkbox />
        </Checkbox>
        <Checkbox
          size="lg"
          isChecked={data.within_twelveweeks}
          onChange={(e) => setData({ ...data, within_twelveweeks: e.target.checked })}
        >
          <Label label="Within 12 Week" color="main.primary" checkbox />
        </Checkbox>
        <Checkbox
          size="lg"
          isChecked={data.returning_worker}
          onChange={(e) => setData({ ...data, returning_worker: e.target.checked })}
        >
          <Label label="Returning Workers" color="main.primary" checkbox />
        </Checkbox>
        <Checkbox
          size="lg"
          isChecked={data.all_workers}
          onChange={(e) => setData({ ...data, all_workers: e.target.checked })}
        >
          <Label label="All Workers" color="main.primary" checkbox />
        </Checkbox>
        {workerType === 'TEMPORARY' && (
          <Checkbox
            size="lg"
            isChecked={data.temp_to_perm_leaver}
            onChange={(e) => setData({ ...data, temp_to_perm_leaver: e.target.checked })}
          >
            <Label label="Temp to Perm Leaver" color="main.primary" checkbox />
          </Checkbox>
        )}
      </Grid>
    </Box>
  );
};

export default SearchWorker;
